import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Modal, Form, Button, Icon, Input, Grid, Table, Pagination, Popup, Select } from 'semantic-ui-react';
import { setActivePage, setQuotesFilter, getQuotes, showLoading, hideLoading, exportOrders, openCustomModal, getHolidays, sortQuotation } from '../actions';
import GetProduct from './GetProduct';

class Quotation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            column: null,
            data: [],
            length: 0,
            page: 0,
            rowsPerPage: 15,
            direction: 'descending',
            formType: null,
            showError: false
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentWillMount() {
        this.props.showLoading('Retrieving quote . . .');
        let cat = (this.props.match.params.cat) ? this.props.match.params.cat : 'All';

        this.props.setQuotesFilter(cat);
        if (cat === 'All') {
            this.props.getQuotes({});
        } else {
            this.props.getQuotes({ status: cat });
        }
    }

    componentDidMount() {
        this.props.setActivePage('quotations');
    }

    componentWillReceiveProps(nextProps) {
        console.log('Quote componentWillReceiveProps');
        if (this.props.quote.quote_list !== nextProps.quote.quote_list) {
            this.setState({ data: _.chunk(nextProps.quote.quote_list, this.state.rowsPerPage), length: nextProps.quote.quote_list.length, column: nextProps.quote.sortColumn, direction: nextProps.quote.sortDirection, page: 0 });
            this.props.hideLoading();
        }
        else if ((this.props.quote.sortColumn !== nextProps.quote.sortColumn) || (this.props.quote.sortDirection !== nextProps.quote.sortDirection)) {
            this.setState({ data: _.chunk(nextProps.quote.list, this.state.rowsPerPage), column: nextProps.quote.sortColumn, direction: nextProps.quote.sortDirection, page: 0 });
        }

        if (this.props.match.params.cat !== nextProps.match.params.cat) {
            console.log(this.props.location.search);
            this.props.showLoading('Retrieving quotes . . .');
            let cat = (nextProps.match.params.cat) ? nextProps.match.params.cat : 'All';

            this.props.setQuotesFilter(cat);
            if (cat === 'All') {
                this.props.getQuotes({});
            } else {
                this.props.getQuotes({ status: cat });
            }
        }
    }

    handleQuoteClick(quote_id, e) {
        // e.preventDefault();
        this.props.history.push('/quotation_details/' + quote_id);
    }

    handleInputChange(e, data) {
        console.log(e);
        console.log(data);
        this.setState({
            [data.id]: data.value
        });
    }

    handleSearchChange = (e) => {
        var sValue = e.target.value;
        this.setState({ searchValue: sValue });
    }

    handleSearchSubmit = (e) => {
        const re = new RegExp(_.escapeRegExp(e.target.value), 'i')
        const isMatch = result => (re.test(result.quote_details.customer.name) || re.test(result._id));

        let list = _.filter(this.props.quote.quote_list, isMatch);
        this.setState({ data: _.chunk(list, this.state.rowsPerPage), length: list.length });
    }

    handleRefresh = () => {
        this.props.showLoading('Retrieving quotes . . .');
        this.props.getQuotes({});
        console.log("Refresh List");
    }

    handleOpen = () => {
        if (this.state.formType) {
            this.props.openCustomModal(true);
        } else {
            this.setState({ showError: true });
        }
    }

    handleDrop = (e, { value }) => {
        this.setState({ formType: value, showError: false });
    }

    handleSort = (clickedColumn) => () => {
        this.props.sortQuotation(clickedColumn);
    }

    render() {
        const { column, data, direction, page, rowsPerPage, length, searchValue, formType } = this.state;

        return (
            <Fragment>
                <Grid>
                    <Grid.Column floated='left' width={4}>
                        <Input icon='search' fluid placeholder='Search...' value={searchValue} onKeyUp={this.handleSearchSubmit} onChange={this.handleSearchChange} />
                    </Grid.Column>
                    <Grid.Column floated='right' width={1}>
                        <Button icon onClick={this.handleRefresh}><Icon name='refresh' /></Button>
                    </Grid.Column>
                </Grid>
                <Table sortable striped selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell style={{ textAlign: 'center' }}>
                                <Icon name='info circle' size='large' />
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === 'quote_date' ? direction : null} onClick={this.handleSort('quote_date')}>
                                Date
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === '_id' ? direction : null} onClick={this.handleSort('_id')}>
                                Quote #
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Ship To
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Total
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === 'name' ? direction : null} onClick={this.handleSort('name')}>
                                Submitter
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {data[page] &&
                            (data.length > 0) ?
                            data[page].map((quoteBundle) => {
                                let quote = quoteBundle.quote_details;
                                let status_icon = '';
                                let status_color = '';

                                if (quoteBundle.status === 'Approved') {
                                    status_icon = 'check circle';
                                    status_color = 'green';
                                }
                                else if (quoteBundle.status === 'Submitted') {
                                    status_icon = 'add circle';
                                    status_color = 'teal';
                                } else {
                                    status_icon = 'remove circle';
                                    status_color = 'red';
                                }

                                return (
                                    <Table.Row key={quoteBundle._id} onClick={this.handleQuoteClick.bind(this, quoteBundle._id)}>
                                        <Table.Cell style={{ textAlign: 'center' }}>
                                            <Icon name={status_icon} color={status_color} size='large' />
                                        </Table.Cell>
                                        <Table.Cell>
                                            {moment(quoteBundle.quote_date).format('DD/MM/YYYY HH:mm')}
                                        </Table.Cell>
                                        <Table.Cell>{quoteBundle._id}</Table.Cell>
                                            <Table.Cell>
                                                <span>{quote.customer.name}</span><br />
                                                <span>{quote.customer.company}</span><br />
                                                <span>{quote.customer.address.address_1},</span>
                                                {(quote.customer.address.address_2.length > 0) && <span>{quote.customer.address.address_2},</span>}
                                                <span>{quote.customer.address.town_city},</span>
                                                <span>{quote.customer.address.postcode} {quote.customer.address.state},</span>
                                                <span>{quote.customer.address.country}</span>
                                            </Table.Cell>
                                        <Table.Cell>
                                            RM {quote.total_amount.toFixed(2)}
                                        </Table.Cell>
                                        <Table.Cell>{quoteBundle.user.name}</Table.Cell>
                                    </Table.Row>
                                )
                            }) :
                            <Table.Row>
                                <Table.Cell colSpan="7" textAlign="center">
                                    No Record Found
                             </Table.Cell>
                            </Table.Row>
                        }
                    </Table.Body>
                </Table>
                <Pagination style={{ float: 'right' }} activePage={page + 1} totalPages={Math.ceil(length / rowsPerPage)} onPageChange={(e, data) => this.setState({ page: data.activePage - 1 })} />
            </Fragment>
        )
    }
}


const mapStateToProps = ({ quote, sales, holiday }) => {
    return { quote, sales, holiday }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setActivePage: setActivePage,
        setQuotesFilter: setQuotesFilter,
        getQuotes: getQuotes,
        showLoading: showLoading,
        hideLoading: hideLoading,
        openCustomModal: openCustomModal,
        getHolidays: getHolidays,
        sortQuotation: sortQuotation
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Quotation);
